import React, {MutableRefObject, useCallback, useEffect, useState} from 'react'
import {createPortal, findDOMNode} from 'react-dom'

import {MentionOption} from "./option"
import Popover from "../../../gd-popover/popover"
import EntitySelector from "../../../entity-selector/selector"
import {EntitySelectorSettings} from "../../editor";

const debug = false
// const debug = "MentionsMenu"

export function MentionsMenu (
    anchorElementRef        : MutableRefObject<HTMLElement | null>,
    itemProps               : {
        selectedIndex           : number | null
        selectOptionAndCleanUp  : (option: MentionOption) => void
        setHighlightedIndex     : (index: number) => void
        options                 : Array<MentionOption>
    },
    matchingString          : string | null,
    mentions?               : any,
    projectId?              : ID,
    entitySelectorSettings? : EntitySelectorSettings
) {
    debug && console.log(debug, 'render', anchorElementRef.current, mentions.length)

    const [isHidden, setIsHidden] = useState(false)

    useEffect(() => {
        debug && console.log(debug, 'useEffect anchorElementRef.current', anchorElementRef.current)
        setIsHidden(false)
    }, [anchorElementRef]);

    const onEntitySelected = useCallback((entity:MentionOption)=>{
        itemProps.selectOptionAndCleanUp(entity)
    }, [])

    const onClickOutside = useCallback((e:any)=>{
        debug && console.log(debug, 'onClickOutside', e)
        setIsHidden(true)
    }, [])

    const onPopoverHide = useCallback(()=>{
        if (anchorElementRef.current) {
            gd.utils.Dom.removeClass(anchorElementRef.current,"visible")
        }

        delete entitySelectorSettings?.entityType
    }, [])

    if (!anchorElementRef.current || isHidden) return null

    if (anchorElementRef.current) {
        gd.utils.Dom.addClass(anchorElementRef.current,"visible")
    }

    return createPortal(
        <Popover attachment         = "bottom left"
                 targetAttachment   = "top left"
                 attachmentType     = "horizontal"
                 onClickOutside     = {onClickOutside}
                 onPopoverHide      = {onPopoverHide}
                 getTargetFunc      = {()=>findDOMNode(anchorElementRef.current)}>
            <EntitySelector userMentions        = {mentions}
                            projectId           = {projectId}
                            initialEntityType   = {entitySelectorSettings?.entityType}
                            onEntitySelected    = {onEntitySelected}/>
        </Popover>,
        anchorElementRef.current,
    )
}
